module.exports = __webpack_public_path__ + "static/media/default_image.6684f358.jpg";